const common = {
  site_name: '布丁漫画网',
  site_tagline: '发现好漫画，从这里开始',
  nav_home: '首页',
  nav_category: '分类',
  nav_rank: '排行榜',
  nav_latest: '最新上架',
  nav_about: '关于我们',
  footer_copyright: '© 2024 布丁漫画网 591chaxin.cn 版权所有',
  footer_privacy: '隐私政策',
  footer_terms: '服务条款',
  footer_contact: '联系我们',
  read_now: '立即阅读',
  view_more: '查看更多',
  all: '全部',
};

export default common;
